module.exports = __webpack_public_path__ + "img/026.07aae50a.jpg";